import React, { ReactElement } from 'react';
import NearMeIcon from '@material-ui/icons/NearMe';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
	AppState,
	MapViewerPanel,
	mapViewerSwitchEditPanel
} from '../../../redux';
import { TooltipIconButton } from '../../atoms';
import { useTranslation } from 'react-i18next';

export interface IMapSelectionControlStateProps {
	isOpen?: boolean;
	toggleSelection: () => void;
}

function MapSelectionControlView(
	props: IMapSelectionControlStateProps
): ReactElement {
	const { isOpen, toggleSelection } = props;
	const { t } = useTranslation('map');

	return (
		<TooltipIconButton
			selected={isOpen}
			onClick={toggleSelection}
			placement="right"
			tooltip={t('actionButtons.edit.select')}
			icon={<NearMeIcon />}
		/>
	);
}

function mapStateToProps(state: AppState) {
	return {
		isOpen: state.mapViewer.panels.get(MapViewerPanel.Selection)
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {
		toggleSelection: () =>
			dispatch(mapViewerSwitchEditPanel(MapViewerPanel.Selection))
	};
}

export const MapSelectionControl = connect(
	mapStateToProps,
	mapDispatchToProps
)(MapSelectionControlView);
